import React from 'react';

const Help = () => {
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-100">Help</h1>
      <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-300">
        User guide coming soon. For assistance contact{' '}
        <a className="font-medium text-zinc-900 hover:underline dark:text-zinc-100" href="mailto:support@core12.com">
          support@core12.com
        </a>
        .
      </p>
    </div>
  );
};

export default Help;
